export default "__VITE_ASSET__e143f196__"